export class Formatters {
    // norm_square
    public norm_square(value: number,
                       valueMin: number,
                       valueMax: number,
                       minRadius: number,
                       maxRadius: number) {
        if (minRadius === maxRadius) {
            throw new Error('min == max!');
        }
        if (!(valueMin !== null && valueMax !== null && minRadius !== null && maxRadius !== null)) {
            return value;
        }
        const minSquare = Math.PI * minRadius * minRadius;
        const maxSquare = Math.PI * maxRadius * maxRadius;
        const diff = valueMax - valueMin;
        const factor = diff !== 0 ? (value - valueMin) / diff : 0;
        const resultSquare = minSquare + factor * (maxSquare - minSquare);
        return Math.sqrt(resultSquare / Math.PI);
    }

    // add
    public add(value: number, value2: number) {
        if (!value && isNaN(Number(value2.toString()))) {
            return value2;
        } else {
            if (isNaN(Number(value.toString())) && !value2) {
                return value;
            }
        }

        return value + value2;
    }

    // date
    public date(value: any, type: any, offset: any) {
        if (value === null) {
            return null;
        }

        const dateTime = new Date(value instanceof Date ? value : Date.parse(value));

        if (offset !== null) {
            dateTime.setTime(dateTime.getTime() + (offset * 3600000));
        }

        // return result
        const year = dateTime.getUTCFullYear();
        let month = dateTime.getUTCMonth() + 1;
        let day = dateTime.getUTCDate();
        let hours = dateTime.getUTCHours();
        let minutes = dateTime.getUTCMinutes();
        let seconds = dateTime.getUTCSeconds();

        const hasHours = hours !== 0;
        const hasMinutes = minutes !== 0;
        const hasSeconds = seconds !== 0;

        month = month < 10 ? 0 + month : month;
        day = day < 10 ? 0 + day : day;
        hours = hours < 10 ? 0 + hours : hours;
        minutes = minutes < 10 ? 0 + minutes : minutes;
        seconds = seconds < 10 ? 0 + seconds : seconds;

        let result = year + '-' + month + '-' + day;
        if (hasHours || hasMinutes || hasSeconds) {
            result += ' ' + hours + ':' + minutes;
        }

        if (hasSeconds) {
            result += ':' + seconds;
        }

        return result;
    }

    // angle
    public angle(point1: any, point2: any) {
        if (!point1) {
            return 0;
        }
        if (!point2) {
            point2 = {x: 0, y: 0};
        }

        const dx = point2.x - point1.x;
        const dy = point2.y - point1.y;

        return Math.atan2(dx, dy);
    }

    // subtract
    public sub(value: any, value2: any) {
        if (isNaN(value)) {
            return value;
        }

        return value - value2;
    }

    // round until 2-4 symbols
    public shorten(value: any) {
        if (isNaN(value)) {
            return value;
        }

        let result;

        value = Math.round(parseFloat(value) * 100) / 100;

        const valueString = String(value);
        const splittedString = valueString.split('.');

        if (splittedString[0].length > 9) {
            result = splittedString[0].substring(0, splittedString[0].length - 9);

            if (result === '-') {
                result = '-0';
            }

            if (result.length < 3) {
                result = result + '.' + splittedString[0][splittedString[0].length - 9];
            }

            return result + 'G';
        } else if (splittedString[0].length > 6) {
            result = splittedString[0].substring(0, splittedString[0].length - 6);

            if (result === '-') {
                result = '-0';
            }

            if (result.length < 3) {
                result = result + '.' + splittedString[0][splittedString[0].length - 6];
            }

            return result + 'M';
        } else if (splittedString[0].length > 3) {
            result = splittedString[0].substring(0, splittedString[0].length - 3);

            if (result === '-') {
                result = '-0';
            }

            if (result.length < 3) {
                result = result + '.' + splittedString[0][splittedString[0].length - 3];
            }

            return result + 'K';
        } else {
            if (splittedString.length > 1) {
                return splittedString[0] + '.' + splittedString[1][0];
            } else {
                return splittedString[0];
            }
        }
    }

    // equals
    public equals(value: any, values: any[]) {
        values.forEach(value2 => {
            if (value2 === value) {
                return true;
            }
        });

        return false;
    }

    // rad -> deg
    public deg(value: any) {
        return value * 180 / Math.PI;
    }

    // max
    public max(value: number, value2: number) {
        if (value > value2) {
            return value;
        } else {
            return value2;
        }
    }

    // mul
    public mul(value: any, value2: any) {
        if (isNaN(value)) {
            return value;
        }
        return value * value2;
    }

    // ifNaN
    public ifNaN(value: number, value2: number) {
        if (!isNaN(value)) {
            return value;
        } else {
            return value2;
        }
    }

    // greater
    public greaterThan(value: number, value2: number) {
        return value > value2;
    }

    // or
    public or(value: any, value2: any) {
        return (value !== null && value) || (value2 !== null && value2);
    }

    // and
    public and(value: any, value2: any) {
        return (value !== null && value) && (value2 !== null && value2);
    }

    // select
    public select(value: any, v0: any, v1: any, v2: any) {
        if (!value) {
            return v0;
        } else if (0 <= value && value < 1) {
                    return v0;
                } else if (1 <= value && value < 2) {
                            return v1;
                        } else if (2 <= value) {
                                    return v2;
                                } else {
                                    return v1;
                                }
    }

    // add-text-height
    public add_text_height(value: any, text: any, styles: any) {

        return 32;
        if (text === null) {
            return value;
        }

        return value + text.height(styles);
    }

    // add-text-width
    public add_text_width(value: any, text: any, styles: any) {
        if (typeof text === 'number') {
            text = this.shorten(text);
        }
        const textString = typeof text !== 'string' ? String(text) : text;
        if (textString === null) {
            return value;
        }
        return value + textString; // .width(styles);
    }

    // div
    public div(value: number, value2: number) {
        if (isNaN(Number(value.toString()))) {
            return value;
        }

        return value / value2;
    }

    // invert
    public invert(value: any) {
        if (isNaN(Number(value.toString()))) {
            return value;
        } else if (typeof(value) === 'number') {
                    return -value;
                } else if (value === null) {
                            return true;
                        } else {
                                return !value;
                            }
    }

    // svg-selected-channel-achor | only SVG elements
    public svg_selected_channel_achor(group: any, gap: any, d: any) {
        if (group === null) {
            return;
        }

        const point = group.point;
        const backwardPoint = group.backwardPoint;
        const r = d / 2;

        const from = backwardPoint.mapObject;
        const to = point.mapObject;
        const angle = Math.atan2((to.y - from.y), (to.x - from.x));
        const denominator = point.flow !== null && backwardPoint.flow !== null ? 3 : 2;

        const flowBreak = {
            x: to.x + (from.x - to.x) / denominator,
            y: to.y + (from.y - to.y) / denominator
        };

        return this.rotate(flowBreak, -r, 0, angle)!;
    }

    // normalize
    public normalize(value: number, minValue: number, maxValue: number, finalMin: number, finalMax: number) {
        const factor = (value - minValue) / (maxValue - minValue);
        return finalMin + (finalMax - finalMin) * factor;
    }

    // get
    public get(value: any, field: string) {
        if (value !== null) {
            return Number(value[field]);
        }
    }

    //#region svg-channel-polygons
    public svg_channel_polygons(channel: any, p1: any, p2: any, p1Flow: any, p2Flow: any,
                                maxFlow: any, minWidth: any, maxWidth: any, gap: any, onlyLast: any = false,
                                hideEmpty: any = false) {
        if ((channel === null || channel === undefined) ||
            (p1 === null || p1 === undefined) || (p2 === null || p2 === undefined)) {
            return;
        }

        let result: any = [];
        if ((p1Flow !== null && p1Flow !== undefined) && (p2Flow !== null && p2Flow !== undefined)) {
            result = this.bothDirectionsFlow(p1, p2, p1Flow, p2Flow, maxFlow, minWidth, maxWidth,
                                              gap, onlyLast, hideEmpty);
        } else if ((p1Flow !== null && p1Flow !== undefined) || (p2Flow !== null && p2Flow !== undefined)) {
            let from;
            let to;
            let flow;
            if (p1Flow !== null && p1Flow !== undefined) {
                from = p2;
                to = p1;
                flow = p1Flow;
            } else {
                from = p1;
                to = p2;
                flow = p2Flow;
            }

            result = this.oneDirectionFlow(from, to, flow, maxFlow, minWidth, maxWidth, gap, onlyLast);
        }

        return result.map(this.convertPoints);
    }

    // every item to "x,y", then split by space
    public convertPoints(points: any) {
        let result = '';

        result = points.map((item: any) => {
            return item.x + ',' + item.y;
        }).join(' ');

        return result;
    }

    // points for 2 directions
    public bothDirectionsFlow(p1: any, p2: any, p1Flow: any, p2Flow: any,
                              maxFlow: any, minWidth: any, maxWidth: any, gap: any, onlyLast: any,
                              hideEmpty: any) {
        const g2 = gap / Math.sin(Math.PI / 4) / 2;
        const widthDiff = maxWidth - minWidth;
        const angle = Math.atan2((p2.y - p1.y), (p2.x - p1.x));

        let factor1 = p1Flow === 0 ? 0 : 1;
        let factor2 = p2Flow === 0 ? 0 : 1;

        if (maxFlow > 0) {
            factor1 = p1Flow / maxFlow;
            factor2 = p2Flow / maxFlow;
        }

        const p1w2 = (minWidth + widthDiff * factor1) / 2;
        const p2w2 = (minWidth + widthDiff * factor2) / 2;
        const w2Max = Math.max(p1w2, p2w2);

        const p1FlowEnd = {
            x: p1.x + (p2.x - p1.x) / 3,
            y: p1.y + (p2.y - p1.y) / 3
        };
        const p2FlowEnd = {
            x: p1.x + 2 * (p2.x - p1.x) / 3,
            y: p1.y + 2 * (p2.y - p1.y) / 3
        };

        const result = [];

        // p1 flow
        if (p1Flow > 0 || !hideEmpty) {
            result.push([
                this.rotate(p1, 0, -p1w2, angle),
                this.rotate(p1FlowEnd, p1w2 - g2, -p1w2, angle),
                this.rotate(p1FlowEnd, -g2, 0, angle),
                this.rotate(p1FlowEnd, p1w2 - g2, p1w2, angle),
                this.rotate(p1, 0, p1w2, angle)
            ]);
        }

        if (!onlyLast) {
            // middle flow
            result.push([
                this.rotate(p1FlowEnd, g2, 0, angle),
                this.rotate(p1FlowEnd, g2 + w2Max, -w2Max, angle),
                this.rotate(p2FlowEnd, -w2Max - g2, -w2Max, angle),
                this.rotate(p2FlowEnd, -g2, 0, angle),
                this.rotate(p2FlowEnd, -w2Max - g2, w2Max, angle),
                this.rotate(p1FlowEnd, g2 + w2Max, w2Max, angle),
            ]);

            // p2 flow
            if (p2Flow > 0 || !hideEmpty) {
                result.push([
                    this.rotate(p2, 0, -p2w2, angle),
                    this.rotate(p2FlowEnd, g2 - p2w2, -p2w2, angle),
                    this.rotate(p2FlowEnd, g2, 0, angle),
                    this.rotate(p2FlowEnd, g2 - p2w2, p2w2, angle),
                    this.rotate(p2, 0, p2w2, angle)
                ]);
            }
        }

        return result;
    }

    // points for 1 direction
    public oneDirectionFlow(from: any, to: any, flow: any, maxFlow: any, minWidth: any,
                            maxWidth: any, gap: any, onlyLast: any) {
        const g2 = gap / Math.sin(Math.PI / 4) / 2;
        const widthDiff = maxWidth - minWidth;
        const angle = Math.atan2((to.y - from.y), (to.x - from.x));

        let factor = flow === 0 ? 0 : 1;

        if (maxFlow > 0) {
            factor = flow / maxFlow;
        }

        const w2 = (minWidth + widthDiff * factor) / 2;

        const flowBreak = {
            x: from.x + (to.x - from.x) / 2,
            y: from.y + (to.y - from.y) / 2
        };

        const result = [];

        if (!onlyLast) {
            // first half
            result.push([
                this.rotate(from, 0, -w2, angle),
                this.rotate(flowBreak, -w2 - g2, -w2, angle),
                this.rotate(flowBreak, -g2, 0, angle),
                this.rotate(flowBreak, -w2 - g2, w2, angle),
                this.rotate(from, 0, w2, angle)
            ]);
        }

        // second half
        result.push([
            this.rotate(to, 0, -w2, angle),
            this.rotate(flowBreak, g2 - w2, -w2, angle),
            this.rotate(flowBreak, g2, 0, angle),
            this.rotate(flowBreak, g2 - w2, w2, angle),
            this.rotate(to, 0, w2, angle)
        ]);

        return result;
    }

    // find and rotate a new point
    private rotate(point: any,
                   dx: number,
                   dy: number,
                   angle: number): any {
        return {
            x: point.x + dx * Math.cos(angle) - dy * Math.sin(angle),
            y: point.y + dx * Math.sin(angle) + dy * Math.cos(angle)
        };
    }
    //#endregion
}
